import i18next from "i18next";
import { useNavigate } from "react-router-dom";
import IDocument from "../../../../Interfaces/workingTime/IWorkingTime";
import IWorkingTimeProp from "../../../../Interfaces/props/IDocumentProp";
import WorkingTimeIcon from "../../../atoms/Icons/DocumentIcon";
import DocumentHeader from "../../headings/WorkingTimeHeader";
import IWorkingTimeStatusDuration from "../../../../Interfaces/workingTime/IWorkingTimeStatusDuration";
import WorkingTimeStatusHeader from "../../headings/WorkingTimeStatusHeader";

const WorkingTimeStatusDurationItem = (prop: IWorkingTimeStatusDuration) => {
  const navigate = useNavigate();
  return (
    <>
      <div className=" d-flex align-items-center media p-4 m-3 mt-1 border-bottom rounded-bottom">
        <WorkingTimeIcon status={prop?.status} />
        <div className="">
          <WorkingTimeStatusHeader
            duration={prop.duration}
            status={prop.status}
          />
          <p>{prop?.status}</p>
        </div>
      </div>
    </>
  );
};
export default WorkingTimeStatusDurationItem;
